/**
 * FAQ Accordion Component
 * Handles expanding/collapsing FAQ items with smooth animations
 */

class FAQAccordion {
  constructor(container) {
    this.container = container;
    this.items = container.querySelectorAll('[data-faq-item]');
    this.init();
  }

  init() {
    this.items.forEach((item, index) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const content = item.querySelector('[data-faq-content]');
      
      if (!trigger || !content) return;

      // Set unique IDs for accessibility
      const id = `faq-${index}`;
      trigger.setAttribute('id', `${id}-trigger`);
      trigger.setAttribute('aria-controls', `${id}-content`);
      content.setAttribute('id', `${id}-content`);
      content.setAttribute('role', 'region');
      content.setAttribute('aria-labelledby', `${id}-trigger`);

      // Add click event
      trigger.addEventListener('click', () => this.toggleItem(item));
    });

    // Open first item by default
    if (this.items.length > 0) {
      this.openItem(this.items[0]);
    }
  }

  toggleItem(item) {
    const isActive = item.getAttribute('data-active') === 'true';
    
    if (isActive) {
      this.closeItem(item);
    } else {
      // Close all other items
      this.items.forEach(otherItem => {
        if (otherItem !== item) {
          this.closeItem(otherItem);
        }
      });
      
      this.openItem(item);
    }
  }

  openItem(item) {
    const trigger = item.querySelector('[data-faq-trigger]');
    const content = item.querySelector('[data-faq-content]');
    
    item.setAttribute('data-active', 'true');
    trigger.setAttribute('aria-expanded', 'true');
    
    // Set max-height for smooth animation
    const contentHeight = content.scrollHeight;
    content.style.maxHeight = `${contentHeight}px`;
  }

  closeItem(item) {
    const trigger = item.querySelector('[data-faq-trigger]');
    const content = item.querySelector('[data-faq-content]');
    
    item.setAttribute('data-active', 'false');
    trigger.setAttribute('aria-expanded', 'false');
    content.style.maxHeight = '0';
  }
}

// Initialize FAQ accordions
function initFAQAccordions() {
  const containers = document.querySelectorAll('[data-faq-container]');
  containers.forEach(container => {
    new FAQAccordion(container);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFAQAccordions);
} else {
  initFAQAccordions();
}

// Re-initialize on Shopify section load (theme editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initFAQAccordions);
}
